module.exports = __webpack_public_path__ + "static/img/indexText5.ae74363.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexText5.png
// module id = Mvfu
// module chunks = 1